// config.pompeufabra.js
  /*
  Institut Pompeu Fabra
  Martotell
  (Jordi Parés)


  especials:

 dades personals:
  adreça desglossada
  observacions necessitats especials

  "progenitor1PM": progenitor1PM, 
  "progenitor1Adreca": progenitor1Adreca, 
  "progenitor1Municipi": progenitor1Municipi, 
  "progenitor1CodiPostal": progenitor1CodiPostal, 
  "progenitor1Provincia": progenitor1Provincia, 
  "progenitor1Pais": progenitor1Pais,

  "progenitor2PM": progenitor2PM, 
  "progenitor2Adreca": progenitor2Adreca, 
  "progenitor2Municipi": progenitor2Municipi, 
  "progenitor2CodiPostal": progenitor2CodiPostal, 
  "progenitor2Provincia": progenitor2Provincia, 
  "progenitor2Pais": progenitor2Pais,



 dades mediques:
  autoritzacio educacio fisica
  contacte emegencia a dades mediques  x2
  llibre vacunacions
  allergia

  quotes
   ordre




  ESO
      1r curs
      2n curs
      3r curs
      4t curs

  Batxillerat
      Batxillerat Artístic
      Batxillerat d'Humanitats i Ciències Socials
      Batxillerat Científic i Tecnològic
  */

const config =
{
    cid: 'a8020620',
    phone: "937 755 916",
    email: "secretaria@iespompeufabra.cat",

    headerLogo:  'img/logo_bn_pompeufabra.png',
    headerTitle:  'Institut Pompeu Fabra',
    headerURL: 'https://matricula.iespompeufabra.cat/',

    //enrollmentPostURL: 'https://matricula.iespompeufabra.cat/post/',
    enrollmentPostURL: '/post/',
    //apiURL: 'https://matricula.iespompeufabra.cat/api/',
    apiURL: '/api/',

    validaIDdocuments: true,  
    tipusDocTSI: true,
    tipusDocPreInscripcio: false,

    fotoCarnet: false,

    telefonObligatori: false,
    carnetFamiliaNombrosa: false,

    contacteEmergenciaObligatori: true,

    adjuntMedic: true,
    adjuntMedicObligatori: false,

    datesNoBloquejenInscripcio: false,

    //NO CALIA!!! >:# 
    noPreguntarSiEsNouAlumne: false,

    notesAcces: true,

    mostraTorns: false,

    autoritzacioReligioAbansTriarAssignatures: true,

    logo: 'img/logo_pompeufabra.jpg',
    titol: 'IES Pompeu Fabra',

    favicon: '/img/favicon-pompeufabra.ico',
    faviconGestio: '/gestio/img/favicon-pompeufabra.ico',

    assignatures: 'assignatures/assignatures.pompeufabra.json',
    families: 'families/families.pompeufabra.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.pompeufabra.json',
    calculquota: 'quotes.pompeufabra.json',

    textNESEB: " <h3>MOTXILLA ESCOLAR</h3> El teu fill/a ha rebut l’ajut de la Motxilla Escolar. L’objecte d’aquest ajut és l'assignació de recursos econòmics als centres, que tenen matriculat per al curs 2025-2026 alumnat NESE B.Generalitat de Catalunya​ Departament d’Educació ​ i Formació Professional Institut Pompeu Fabra.  <br/> Els imports que els centres rebran en relació amb le​s motxilles de l’alumnat d'ESO, en el cas dels centres públics van destinats a: <ul> <li>Quota de material escolar</li> <li>Sortides i colònies</li> <li>Llibres</li> </ul> <p>Per tant, no és necessari pagar la quota de material ni despeses derivades d’activitats pedagògiques del centre.</p>",

    /* camps especifics per centre */
    treballantFile: true,
    necessitatsEducativesEspecials: true,

    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,

    textDadesMediquesAlgunSi: "Sempre que sigui imprescindible administrar medicaments a l'alumnat en l'horari lectiu, caldrà prèviament que els pares, mares o tutors legals aportin la documentació següent:<ul><li>Un <b>informe mèdic</b> on consti el nom de l'alumne o alumna, el nom del medicament que ha de prendre i la pauta d'administració.</li> <li>Una <b>autorització</b> on se sol·liciti a la direcció del centre educatiu l'administració a l'alumne o alumna del medicament prescrit, d'acord amb les pautes que constin en l'informe esmentat anteriorment, i se n'autoritzi l'administració al personal del centre.</li></ul> ",




    textTriarAssignatures: {
      ESOLOE01:  `Les matèries Optatives i els Projectes són matèries que l’alumnat pot triar. Impliquen 2 hores a la setmana i duren un quadrimestre, serveixen per iniciar, reforçar o ampliar la resta de matèries que es fan.<br/>
En el full de tria, l’alumnat fa l’elecció de la matèria Optativa i del Projecte que farà durant el primer quadrimestre. Al llarg del curs es farà la tria de les optatives i projectes del segon quadrimestre.<br/>
L’oferta d’optatives i projectes pot sofrir modificacions per canvis a nivell d’organització. Aquestes modificacions seran comunicades a l’alumnat. De qualsevol manera, la tria de matèries Optatives i de projectes serà revisada per les tutories i professorat per tal que sigui correcta i coherent. Es podrà assignar una matèria optativa de forma automàtica a l’alumnat que no ha superat alguna CB de primària.<br/>
Cal que  <b>numereu TOTES les optatives i TOTS els projectes</b> per ordre de preferència, posant l’1 a la matèria que més us interessa, un 2 a la següent i així successivament fins que totes les optatives i tots els projectes tinguin un número.<br/>
      `,

      BATX:  `<div>Aquí trobareu la descripció detallada de matèries de cadascun de les modalitats de Batxillerats:
      <ul>
               <li><a href="/docs/Descripcio-materies-Arts-via-plastica.pdf" target="_blank" rel="noreferrer">Batxillerat Arts</a></li>
               <li><a href="/docs/Descripcio-materies-Cientific-Tecnologic.pdf" target="_blank" rel="noreferrer">Batxillerat Científic-Tecnològic</a></li>  
               <li><a href="/docs/Descripcio-materies-Humanistic-Social.pdf" target="_blank" rel="noreferrer">Batxillerat Humanístic-Social</a></li>
      </ul>

      L'acceptació d'una matèria optativa o una altra estarà supeditada al nombre de grups que es puguin crear i als criteris organitzatius interns del centre.
      </div>
      `

      },

    batxilleratNocturnText: "Heu de fer constar la vostra situació acadèmica. Les matèries pendents que pugueu tenir, les matèries que ja heu fet, si feu matèries soltes o flexibilització. Qualsevol informació rellevant per la vostra matrícula.",

    textBotoMatricular: "INSCRIURE",

    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: "Si has fet preinscripció pel curs 2025-2026, marca SÍ, per la resta de casos cal indicar NO. Si el curs 2024-2025 has estudiat en el nostre centre marca NO",

    urlTPV: "https://matricula.iespompeufabra.cat/tpv/",
    pagamentTPV: true,
    pagamentTransferencia: false,

    sexeNoBinari: false,

    pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{0,2}$/,
    pattern_1r_batx: /^BATXLOE\d{4}1[^N]?[A-Z]{0,2}$/,
    pattern_2n_batx: /^BATXLOE\d{4}2[^N]?[A-Z]{0,2}$/,

    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
  };

export default  config;
